export default {
      id: "email-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#email",
      toString: function () {
        return this.url;
      }
    }